const getPreviewState = (state) => state.preview

export const selectIsPagePreviewOpened = (state) => getPreviewState(state).isPagePreviewerOpened
export const selectIsCanvasPreviewerOpened = (state) => getPreviewState(state).isCanvasPreviewerOpened
export const selectPreviewPageId = (state) => getPreviewState(state).previewPageId



// WEBPACK FOOTER //
// ./src/store/preview/previewSelectors.js